export default function getVisitStatus(visit) {
  const visitStatus = {
    isRejected: visit.status === 0,
    isConfirmed: visit.status === 1,
    isCanceled: visit.status === 2,
    isPending: visit.status === 3,
    isPast: visit.status === 4,
    isFinished: visit.status === 5,
  }

  return visitStatus
}
